define('enums/architect/FlowType',[],function () {
    'use strict';
    return {
        INBOUNDCALL: "INBOUNDCALL",
        INBOUNDEMAIL: "INBOUNDEMAIL", 
        INBOUNDSHORTMESSAGE: "INBOUNDSHORTMESSAGE", 
        INQUEUECALL: "INQUEUECALL", 
        OUTBOUNDCALL: "OUTBOUNDCALL", 
        SECURECALL: "SECURECALL", 
        SPEECH: "SPEECH", 
        SURVEYINVITE: "SURVEYINVITE", 
        WORKFLOW: "WORKFLOW"
    };
});
